var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-0 pa-0",attrs:{"color":"green"}},[_c('v-card',{staticClass:"pt-4 ml-2"},_vm._l((Object.keys(_vm.options)),function(entry,index){return _c('solver-option',{key:index,attrs:{"optimization":_vm.optimization,"name":entry,"value":_vm.options[entry]}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }